import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { BreadcrumbModule } from 'xng-breadcrumb';

import { NotificationIconComponent } from './notification-icon/notification-icon.component';
import { PortalPageHeaderComponent } from './portal-page-header/portal-page-header.component';

@NgModule({
  imports: [
    CommonModule,
    MatMenuModule,
    MatDividerModule,
    MatToolbarModule,
    BreadcrumbModule,
    MatIconModule,
    RouterModule,
    MatButtonModule,
    I18NextModule,
  ],
  declarations: [PortalPageHeaderComponent, NotificationIconComponent],
  exports: [PortalPageHeaderComponent, NotificationIconComponent],
})
export class SharedUiHeadersModule {}
